export default {
  base_path: '/'
}



// WEBPACK FOOTER //
// ./src/Config.js